import { OneInchNetwork } from '@api';

import { wagmiConfig, WagmiConfigChain } from '@shared/common/providers/Web3Provider/wagmi';

const getVerifiedMagicSwapNetworkId = (network?: OneInchNetwork) => {
  if (!network) {
    throw new Error('Please provide a network');
  }

  const isSupportedChain = wagmiConfig.chains.find((chain) => chain.id === network.id);

  if (!isSupportedChain) {
    throw new Error(`Chain ${network.attributes.name}(${network.id}) not supported`);
  }

  return network.id as unknown as WagmiConfigChain['id'];
};

export default getVerifiedMagicSwapNetworkId;
